import { useState } from 'react';
import { addDoc, collection } from 'firebase/firestore';
import { db } from '../../utils/firebase.util';

const defaultFormFields = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  message: '',
};

const ContactForm = ({ closeForm }) => {
  const [formFields, setFormFields] = useState(defaultFormFields);
  const { firstName, lastName, email, phone, message } = formFields;
  const clientsCollectionRef = collection(db, 'clients');

  const resetFormFields = () => {
    setFormFields(defaultFormFields);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormFields({ ...formFields, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await addDoc(clientsCollectionRef, formFields);
    alert('submitted succesfully!'); // TODO: Add toast or modal, or redirect, or whatever...
    resetFormFields();
    // for modal
    if (closeForm) {
      closeForm();
    }
  };

  return (
    <div className='contact form'>
      <h3>Заповнити Анкету</h3>
      <form onSubmit={handleSubmit}>
        <div className='formBox'>
          <div className='row50'>
            <div className='inputBox'>
              <span>Ваше Ім'я</span>
              <input
                type='text'
                placeholder='Сергій'
                required
                onChange={handleChange}
                name='firstName'
                value={firstName}
              />
            </div>
            <div className='inputBox'>
              <span>Ваше Прізвище</span>
              <input
                type='text'
                placeholder='Вавілов'
                required
                onChange={handleChange}
                name='lastName'
                value={lastName}
              />
            </div>
          </div>

          <div className='row50'>
            <div className='inputBox'>
              <span>Ваш Email</span>
              <input
                type='email'
                placeholder='serhiivavilov@gmail.com'
                required
                onChange={handleChange}
                name='email'
                value={email}
              />
            </div>
            <div className='inputBox'>
              <span>Ваш Номер Телефону</span>
              <input
                type='text'
                placeholder='+380 97 13 54 123'
                required
                onChange={handleChange}
                name='phone'
                value={phone}
              />
            </div>
          </div>

          <div className='row100'>
            <div className='inputBox'>
              <span>Ваше Повідомлення</span>
              <textarea
                placeholder='Напишіть Ваше повідомлення тут...'
                required
                onChange={handleChange}
                name='message'
                value={message}
              ></textarea>
            </div>
          </div>

          <div className='row100'>
            <div className='inputBox'>
              <input type='submit' value='Відправити Анкету' />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default ContactForm;
